// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".src-containers-Login-Login-module__Login--1Hhye {\n  text-align: center;\n  margin: 0 auto;\n}\n\n.src-containers-Login-Login-module__Logo--3RW6o {\n  margin: 0 auto;\n  text-align: center;\n  height: 200px;\n  display: block;\n  color: #ad0900;\n  margin-bottom: 10px;\n}\n", ""]);
// Exports
exports.locals = {
	"Login": "src-containers-Login-Login-module__Login--1Hhye",
	"Logo": "src-containers-Login-Login-module__Logo--3RW6o"
};
module.exports = exports;
